import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React, { lazy } from 'react';
import { autorun } from 'mobx';
import { addDisposer, cast, types } from 'mobx-state-tree';
import { ConfigurationReference, ConfigurationSchema, getConf } from '@jbrowse/core/configuration';
import { getSession, getContainingView } from '@jbrowse/core/util';
import { BaseLinearDisplay } from '@jbrowse/plugin-linear-genome-view';
// icons
import PaletteIcon from '@mui/icons-material/Palette';
import FilterListIcon from '@mui/icons-material/ClearAll';
// locals
import { FilterModel } from '../shared';
import drawFeats from './drawFeats';
import { fetchChains } from '../shared/fetchChains';
// async
var FilterByTagDlg = lazy(function () {
  return import('../shared/FilterByTag');
});
// stabilize clipid under test for snapshot
function getId(id) {
  var isJest = typeof jest === 'undefined';
  return "arc-clip-".concat(isJest ? id : 'jest');
}
/**
 * #stateModel LinearReadArcsDisplay
 * extends `BaseLinearDisplay`
 */
function stateModelFactory(configSchema) {
  return types.compose('LinearReadArcsDisplay', BaseLinearDisplay, types.model({
    /**
     * #property
     */
    type: types.literal('LinearReadArcsDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema),
    /**
     * #property
     */
    filterBy: types.optional(FilterModel, {}),
    /**
     * #property
     */
    lineWidth: types.maybe(types.number),
    /**
     * #property
     */
    jitter: types.maybe(types.number),
    /**
     * #property
     */
    colorBy: types.maybe(types.model({
      type: types.string,
      tag: types.maybe(types.string),
      extra: types.frozen()
    })),
    /**
     * #property
     */
    drawInter: true,
    /**
     * #property
     */
    drawLongRange: true
  })).volatile(function () {
    return {
      loading: false,
      drawn: false,
      chainData: undefined,
      ref: null,
      lastDrawnOffsetPx: 0
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       * internal, a reference to a HTMLCanvas because we use a autorun to draw the canvas
       */
      reload: function reload() {
        self.error = undefined;
      },
      /**
       * #action
       * internal, a reference to a HTMLCanvas because we use a autorun to draw the canvas
       */
      setRef: function setRef(ref) {
        self.ref = ref;
      },
      /**
       * #action
       */
      setColorScheme: function setColorScheme(s) {
        self.colorBy = cast(s);
      },
      /**
       * #action
       */
      setChainData: function setChainData(args) {
        self.chainData = args;
      },
      /**
       * #action
       */
      setDrawInter: function setDrawInter(f) {
        self.drawInter = f;
      },
      /**
       * #action
       */
      setDrawLongRange: function setDrawLongRange(f) {
        self.drawLongRange = f;
      },
      /**
       * #action
       */
      setLoading: function setLoading(f) {
        self.loading = f;
      },
      /**
       * #action
       * used during tests to detect when we can complete a snapshot test
       */
      setDrawn: function setDrawn(f) {
        self.drawn = f;
      },
      /**
       * #action
       */
      setFilterBy: function setFilterBy(filter) {
        self.filterBy = cast(filter);
      },
      /**
       * #action
       * allows the drawing to slide around a little bit if it takes a long time to refresh
       */
      setLastDrawnOffsetPx: function setLastDrawnOffsetPx(n) {
        self.lastDrawnOffsetPx = n;
      },
      /**
       * #action
       * thin, bold, extrabold, etc
       */
      setLineWidth: function setLineWidth(n) {
        self.lineWidth = n;
      },
      /**
       * #action
       * jitter val, helpful to jitter the x direction so you see better evidence when e.g. 100
       * long reads map to same x position
       */
      setJitter: function setJitter(n) {
        self.jitter = n;
      }
    };
  }).views(function (self) {
    var superTrackMenuItems = self.trackMenuItems,
      superRenderProps = self.renderProps;
    return {
      /**
       * #getter
       */
      get lineWidthSetting() {
        var _a;
        return (_a = self.lineWidth) !== null && _a !== void 0 ? _a : getConf(self, 'lineWidth');
      },
      /**
       * #getter
       */
      get jitterVal() {
        var _a;
        return (_a = self.jitter) !== null && _a !== void 0 ? _a : getConf(self, 'jitter');
      },
      /**
       * #getter
       */
      get ready() {
        return !!self.chainData;
      },
      // we don't use a server side renderer, but we need to provide this
      // to avoid confusing the system currently
      get rendererTypeName() {
        return 'PileupRenderer';
      },
      // we don't use a server side renderer, so this fills in minimal
      // info so as not to crash
      renderProps: function renderProps() {
        return _objectSpread({}, superRenderProps(), {
          // never ready, we don't want to use server side render
          notReady: true,
          config: ConfigurationSchema('empty', {}).create()
        });
      },
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [].concat(_toConsumableArray(superTrackMenuItems()), [{
          label: 'Filter by',
          icon: FilterListIcon,
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [FilterByTagDlg, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }, {
          label: 'Line width',
          subMenu: [{
            label: 'Thin',
            onClick: function onClick() {
              return self.setLineWidth(1);
            }
          }, {
            label: 'Bold',
            onClick: function onClick() {
              return self.setLineWidth(2);
            }
          }, {
            label: 'Extra bold',
            onClick: function onClick() {
              return self.setLineWidth(5);
            }
          }]
        }, {
          label: 'Jitter x-positions',
          subMenu: [{
            type: 'checkbox',
            checked: this.jitterVal === 0,
            label: 'None',
            onClick: function onClick() {
              return self.setJitter(0);
            }
          }, {
            type: 'checkbox',
            checked: this.jitterVal === 2,
            label: 'Small',
            onClick: function onClick() {
              return self.setJitter(2);
            }
          }, {
            type: 'checkbox',
            checked: this.jitterVal === 10,
            label: 'Large',
            onClick: function onClick() {
              return self.setJitter(10);
            }
          }]
        }, {
          label: 'Draw inter-region vertical lines',
          type: 'checkbox',
          checked: self.drawInter,
          onClick: function onClick() {
            return self.setDrawInter(!self.drawInter);
          }
        }, {
          label: 'Draw long range connections',
          type: 'checkbox',
          checked: self.drawLongRange,
          onClick: function onClick() {
            return self.setDrawLongRange(!self.drawLongRange);
          }
        }, {
          label: 'Color scheme',
          icon: PaletteIcon,
          subMenu: [{
            label: 'Insert size ± 3σ and orientation',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'insertSizeAndOrientation'
              });
            }
          }, {
            label: 'Insert size ± 3σ',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'insertSize'
              });
            }
          }, {
            label: 'Orientation',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'orientation'
              });
            }
          }, {
            label: 'Insert size gradient',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'gradient'
              });
            }
          }]
        }]);
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      renderSvg: function () {
        var _renderSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
          var view, width, height, str, canvas, ctx, C2S, _ctx, clipid;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                view = getContainingView(self);
                width = view.dynamicBlocks.totalWidthPx;
                height = self.height;
                if (!opts.rasterizeLayers) {
                  _context.next = 16;
                  break;
                }
                canvas = document.createElement('canvas');
                canvas.width = width * 2;
                canvas.height = height * 2;
                ctx = canvas.getContext('2d');
                if (ctx) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return");
              case 10:
                ctx.scale(2, 2);
                _context.next = 13;
                return drawFeats(self, ctx);
              case 13:
                str = React.createElement("image", {
                  width: width,
                  height: height,
                  xlinkHref: canvas.toDataURL('image/png')
                });
                _context.next = 24;
                break;
              case 16:
                _context.next = 18;
                return import('canvas2svg');
              case 18:
                C2S = _context.sent;
                _ctx = new C2S.default(width, height);
                _context.next = 22;
                return drawFeats(self, _ctx);
              case 22:
                clipid = getId(self.id);
                str = React.createElement(React.Fragment, null, React.createElement("defs", null, React.createElement("clipPath", {
                  id: clipid
                }, React.createElement("rect", {
                  x: 0,
                  y: 0,
                  width: width,
                  height: height
                }))), React.createElement("g", {
                  /* eslint-disable-next-line react/no-danger */
                  dangerouslySetInnerHTML: {
                    __html: _ctx.getSvg().innerHTML
                  },
                  clipPath: "url(#".concat(clipid, ")")
                }));
              case 24:
                return _context.abrupt("return", React.createElement(React.Fragment, null, str));
              case 25:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function renderSvg(_x) {
          return _renderSvg.apply(this, arguments);
        }
        return renderSvg;
      }()
    };
  }).actions(function (self) {
    return {
      afterAttach: function afterAttach() {
        addDisposer(self, autorun(function () {
          return fetchChains(self);
        }, {
          delay: 1000
        }));
        addDisposer(self, autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var canvas, ctx;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                canvas = self.ref;
                if (canvas) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                ctx = canvas.getContext('2d');
                if (ctx) {
                  _context2.next = 7;
                  break;
                }
                return _context2.abrupt("return");
              case 7:
                ctx.clearRect(0, 0, canvas.width, self.height * 2);
                ctx.resetTransform();
                ctx.scale(2, 2);
                _context2.next = 12;
                return drawFeats(self, ctx);
              case 12:
                self.setDrawn(true);
                _context2.next = 19;
                break;
              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);
                self.setError(_context2.t0);
              case 19:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 15]]);
        })), {
          delay: 1000
        }));
      }
    };
  });
}
export default stateModelFactory;